import {  useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import axiosInstance from '../utils/axiosInstance';

const Logout = ( {authenticatedUser, setAuthenticatedUser, isAdmin, setAdmin} ) => {
    const navigate = useNavigate();

    useEffect(() => {
        if(authenticatedUser !== null) {
            axiosInstance.delete('/logout', {withCredentials:true} )
            .then(response => {
                setAuthenticatedUser(null);
                setAdmin(false);
                navigate("/login");
            })
            .catch(error => {
                console.log(error)
            });
        }
        else {
            navigate("/login")
        }
    }, [])  

    return
};
 
export default Logout;